import { useCallback, useState } from "react";

import { DetailsPanelType } from "./details_panel_context_provider";
type StackItemType = DetailsPanelType | "booking_form";

export type UseDisplayOrderType = {
  pushToDisplayOrderStack: (type: StackItemType) => void;
  popFromDisplayOrderStack: () => void;
  clearDisplayOrderStack: () => void;
  checkTopValue: (type: StackItemType) => boolean;
};
export const useDisplayOrder = (): UseDisplayOrderType => {
  const [sidePanelStack, setSidePanelStack] = useState<StackItemType[]>([]);

  const pushToStack = useCallback((type: StackItemType) => {
    setSidePanelStack((prev) => {
      if (prev.includes(type)) {
        return [...prev.filter((item) => item !== type), type];
      }
      return [...prev, type];
    });
  }, []);

  const popFromStack = useCallback(() => {
    setSidePanelStack((prev) => prev.slice(0, prev.length - 1));
  }, []);

  const clearStack = useCallback(() => {
    setSidePanelStack([]);
  }, []);

  const checkTopValue = useCallback(
    (type: StackItemType) => {
      if (sidePanelStack.length === 0) {
        return false;
      }
      return sidePanelStack[sidePanelStack.length - 1] === type;
    },
    [sidePanelStack]
  );

  return {
    pushToDisplayOrderStack: pushToStack,
    popFromDisplayOrderStack: popFromStack,
    clearDisplayOrderStack: clearStack,
    checkTopValue
  };
};
